import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import './Portfolio.css'
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
export default class Portfolio extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
}


  render() {
    return (
      <div>
        <Container className="mt-9">
          <div className="hero-text-2 text-center">
            <p>
              <span className="hero-text-color-1">Transforming</span> Ideas into
              <br />
              Impactful
              <span className="hero-text-color-1">Digital Realities</span>
            </p>
          </div>
          <p className="text-center">
            At Ambrum, we transform ambitious ideas into digital realities <br />
            blending smart software solutions with impactful marketing to shape
            the future of business.
          </p>
          <div className="project-card py-5 mt-5">
            <div className="image-section">
              <img src="./assets/images/mockup.png" alt="Project Screenshot" />
            </div>
            <div className="content-section">
              <p className="tag">Find My Doc</p>
              <h3>
                A dynamic medical booking management platform connecting
                patients with doctors and hospitals digitally.
              </h3>
              <p className="description">
                We built a comprehensive doctor channeling and medical center management solution
                that connects patients, doctors, and hospitals in one platform. With smart features
                like medical records, online booking, and family profiles, FMD enhances healthcare
                accessibility across Sri Lanka.
              </p>
              <Link to="/project-view" className="project-link">
                View Project &gt;
              </Link>
            </div>
          </div>

          <div className="project-card py-5 mt-5">
            <div className="image-section">
              <img src="./assets/images/rcgcMobileLogo.png" alt="Project Screenshot" />
            </div>
            <div className="content-section">
              <p className="tag">Royal Colombo Golf Club</p>
              <h3>
                Developed a user-friendly website for the prestigious
                Royal Colombo Golf Club, enhancing their online presence and
                member engagement.
              </h3>
              <p className="description">
                Ambrum redesigned the Royal Colombo Golf Club’s official website with a clean,
                responsive layout that highlights tradition and prestige while enabling smooth
                event updates, member login, and contact features to elevate user experience.
              </p>
              {/* <a href="#" className="project-link">
              View Project &gt;
            </a> */}
            </div>
          </div>

          <div className="project-card py-5 mt-5">
            <div className="image-section">
              <img src="./assets/images/voltChargeLogo.png" alt="Project Screenshot" />
            </div>
            <div className="content-section">
              <p className="tag">Volt Charge</p>
              <h3>
                VoltCharge – Powering the Future of Electric Mobility
                An intelligent EV charging ecosystem designed for convenience,
                sustainability, and scalability.
              </h3>
              <p className="description">
                VoltCharge is a cutting-edge EV charging solution designed to accelerate sustainable
                mobility. Built with intelligent backend systems and a user-friendly interface, it supports
                seamless station management, user payments, and real-time tracking, empowering
                Sri Lanka’s growing electric vehicle infrastructure.
              </p>
              {/* <a href="#" className="project-link">
              View Project &gt;
            </a> */}
            </div>
          </div>

          <div className="project-card py-5 mt-5">
            <div className="image-section">
              <img src="./assets/images/letstalkLogo.png" alt="Project Screenshot" />
            </div>
            <div className="content-section">
              <p className="tag">Let's Talk</p>
              <h3>
                Let’s Talk – Australia’s Smart Consultation & Appointment App
                Empowering professionals and clients to connect, consult, and
                schedule with ease—anytime, anywhere.
              </h3>
              <p className="description">
                Let’s Talk is a smart consultation and scheduling app based in Australia.
                It bridges professionals and clients across sectors, offering effortless appointment
                booking, secure communication, and calendar integration, all in one sleek and
                reliable mobile platform.
              </p>
              {/* <a href="#" className="project-link">
              View Project &gt;
            </a> */}
            </div>
          </div>
        </Container>


        <ContactUsFooter />
        <br />
        <Footer />
      </div>

    );
  }
}
